<template>
  <page-header :breadcrumRoutes="routes" title="Baja de cargas individual">
    <template #tags>
      <tags
        :stateId="ticket_state_id"
        :loading="true"
        v-if="ticket_state_id !== ''"
      />
      <tags :stateId="1" :loading="true" v-else />
      <tags color="processing">ID: {{ id_baja }}</tags>
    </template>

    <template #buttons v-if="user_role != 'rrhh'">
      <a-button
        v-if="availableActions.cancel"
        @click="openCancelModal"
        :disabled="loading"
        :loading="loading"
      >
        Cancelar
      </a-button>
      <a-button
        v-if="availableActions.editEndDate"
        @click="() => (updateEndDateVisible = true)"
        class="ml-2"
        :disabled="loading"
        :loading="loading"
      >
        Editar fecha de término
      </a-button>
      <a-button
        v-if="availableActions.sendToInsurance"
        type="primary"
        class="ml-2"
        :loading="loading"
        :disabled="loading"
        @click="openSendToInsuranceModal"
      >
        Enviar a aseguradora
      </a-button>
      <a-button
        v-if="availableActions.finish"
        type="primary"
        class="ml-2"
        :loading="loading"
        :disabled="loading"
        @click="openExecuteModal"
      >
        Ejecutar
      </a-button>
    </template>

    <template #content-below-title>
      <div
        v-if="ticket.ticketGroupId"
        style="margin-top: 0px; font-size: 14px"
        class="ant-page-header-content"
      >
        <a-button
          type="primary"
          class="mb-0"
          @click="goToTicketGroup(ticket.ticketGroupId)"
        >
          Ticket masivo: #{{ ticket.ticketGroupId }}
        </a-button>
      </div>
    </template>
  </page-header>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="updateEndDateVisible"
    title="Editar fecha de término"
    @ok="updateEndDate"
  >
    <a-date-picker
      format="DD-MM-YYYY"
      style="width: 100%"
      v-model:value="newEndDate"
    />
  </a-modal>

  <stepper
    ticketType="baja"
    :state="stepper_props.state"
    :stateDates="stepper_props.dates"
    ref="stepper_ref"
  />

  <a-card>
    <a-row :gutter="[16, 16]">
      <a-col :xs="24" :md="12">
        <datos-ticket
          :data="data_to_table"
          title="Datos corporativos"
          :loadTicket="loadTicket"
        />

        <a-card
          v-if="user_role != 'rrhh'"
          class="mt-3"
          title="Casos asociados"
          bodyStyle="padding: 24px 24px 24px 24px; border: 1px solid #f0f0f0; border-top-width: 0px;"
          :bordered="false"
        >
          <div v-if="cases.length == 0">
            <a-typography-text>No existen casos</a-typography-text>
          </div>

          <a-row
            type="flex"
            justify="space-between"
            v-for="c in cases"
            :key="c.id"
          >
            <a-col :span="6">
              <a-typography-text>{{ c.state }}</a-typography-text>
            </a-col>
            <a-col>
              <tags :stateId="c.tag" />
            </a-col>
            <a-col>
              <a-button type="link" @click="redirectCase(c)">
                Ir a caso
              </a-button>
            </a-col>
            <a-divider class="my-2" v-if="cases.length > 1" />
          </a-row>
        </a-card>
      </a-col>
      <a-col :xs="24" :md="12">
        <records
          title="Historial"
          :loadingHistory="loadingHistory"
          :data="ordered_records"
          v-if="user_role != 'rrhh'"
        />

        <a-table
          class="mt-3"
          rowKey="id"
          :columns="v2ExclusionColumns"
          :data-source="v2ExclusionRows"
          :pagination="false"
          :loading="loadingDependents"
        >
          <template #title>Coberturas a dar de baja</template>
        </a-table>

        <attached-documents
          v-if="user_role != 'rrhh' && ticketOptionalFiles.length > 0"
          class="mt-3"
          title="Archivos opcionales"
          :data="ticketOptionalFiles"
          :loading="loadingOptionalFiles"
        />

        <mensaje-aseguradora
          v-if="
            ticket.messageInsurance != '' &&
            ticket.messageInsurance != null &&
            user_role !== 'rrhh'
          "
          class="mt-3"
          :message="ticket.messageInsurance"
        />

        <comments
          v-if="user_role != 'rrhh'"
          class="mt-3"
          :comments="comments_ordered"
          :idToTicket="id_baja"
          @new_comment="getNewCommment"
        />
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { reactive, ref, computed, createVNode, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import openNotificationWithIcon from '@/utils/notifications';
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex';
import Stepper from '@/components/tickets/stepper.vue';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import Records from '@/components/tickets/records.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import notification from '@/utils/notifications';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
// eslint-disable-next-line no-unused-vars
import Comments from '@/components/tickets/comments.vue';
import parseDate from '@/utils/dateFormatter';
import { normalizePicker } from '@/utils/calendarDay';
import { useTicketStepper } from '@/composables/use-ticket-stepper';
import {
  GET_LOGGED_USER,
  FETCH_TICKET_ID,
  FETCH_TICKET_COMMENTS_ID,
  FETCH_CASES,
  FETCH_USER_BY_ID,
  FETCH_RECORD_FILE_TICKET,
  UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION,
  FETCH_TICKET_OPTIONAL_FILES,
  GET_TICKET_OPTIONAL_FILES,
  FETCH_DEPENDENTS_EXCLUSION_OF_TICKET
} from '@/store/types';
import { FETCH_V2_DEPENDENTS_EXCLUSION_OF_TICKET } from '@/store/ticket/dependents-exclusion/individualExclusion/types';
import {
  getAvailableActions,
  mapV2RecordsToDisplay,
  normalizeV1ExclusionRecords,
  createStatusActions
} from '../individual-detail-actions';
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import rutHelper from '@/utils/Ruts';

export default {
  name: 'BajaCargasDetalle',
  components: {
    stepper: Stepper,
    'datos-ticket': DatosTicket,
    records: Records,
    'attached-documents': AttachedDocuments,
    comments: Comments,
    'mensaje-aseguradora': MensajeAseguradora,
    'page-header': PageHeader,
    tags: Tags
  },
  setup() {
    // * VUEX
    const store = useStore();
    const user_role = store.getters[GET_LOGGED_USER].roleName;
    const showOnlyCancel = ref(false);
    const loadTicket = ref(false);
    const loadingHistory = ref(false);

    const goToTicketGroup = (id) => {
      router.push({
        name: 'BajaCargasMasivaDetalle',
        params: { id }
      });
    };
    // * Obtener la id desde la ruta url en la que estoy
    const route = useRoute();
    const id_baja = route.params.id; // id de la baja que estoy viendo

    const updateEndDateVisible = ref(false);
    const newEndDate = ref();

    const updateEndDate = async () => {
      try {
        if (!newEndDate.value) {
          notification('error', 'Error', 'Debe seleccionar una fecha.');
          return;
        }
        await store.dispatch(UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION, {
          id: id_baja,
          endDate: normalizePicker(newEndDate.value)
        });
        await getTicketData(id_baja);
        updateEndDateVisible.value = false;
        newEndDate.value = undefined;
      } catch (error) {
        console.error(error);
        let errMsg = error?.response?.data?.message;
        if (!errMsg) {
          errMsg =
            'Ha ocurrido un error al cambiar la fecha de término. Favor intentar más tarde.';
        }
        notification('error', 'Error', errMsg);
      }
    };

    // * Rutas
    const routes = [
      {
        path: '/bajas-cargas',
        breadcrumbName: 'Bajas cargas'
      },
      {
        breadcrumbName: `#${id_baja}`
      }
    ];

    const getBroker = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    // * Stepper
    const stepper_ref = ref('null');

    const router = useRouter();
    const records_comments = reactive([]);
    const records_files = reactive([]);
    const ticketOptionalFiles = ref([]);
    const loadingOptionalFiles = ref(false);

    const {
      recordsSteps: records_steps,
      stepperProps: stepper_props,
      headerStateData: header_state_data,
      ticketStateId: ticket_state_id,
      rebuild: rebuildStepper
    } = useTicketStepper(null, {
      onCancel: () => stepper_ref.value?.cancelStep?.(),
      onFinish: () => stepper_ref.value?.finishStep?.()
    });

    const getTicketOptionalFiles = async () => {
      loadingOptionalFiles.value = true;
      try {
        if (user_role != 'rrhh') {
          await store.dispatch(FETCH_TICKET_OPTIONAL_FILES, id_baja);
        }
        ticketOptionalFiles.value =
          await store.getters[GET_TICKET_OPTIONAL_FILES];
        loadingOptionalFiles.value = false;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar archivos opcionales del Ticket ${id_baja}. ${error}`
        );
        loadingOptionalFiles.value = false;
      }
    };

    const stepperData = async (id, ticketDataParam) => {
      // Thin wrapper: fetch the ticket (or reuse a pre-fetched payload)
      // and delegate stepper-state construction to useTicketStepper.
      // The 5x-duplicated stepper-building algorithm + getStateType
      // switch-case now lives in src/composables/use-ticket-stepper.js.
      loadingHistory.value = true;
      try {
        let ticket_data;
        if (ticketDataParam) {
          ticket_data = ticketDataParam;
        } else {
          const ticket_response = await store
            .dispatch(FETCH_TICKET_ID, id)
            .catch((e) => e.response);
          ticket_data = ticket_response.data;
        }
        if (ticket_data.type.id != 6) {
          return router.push({ name: 'Missing' });
        }
        showOnlyCancel.value = false;
        rebuildStepper(ticket_data);
        loadingHistory.value = false;
      } catch (error) {
        loadingHistory.value = false;
        console.log('error', error);
      }
    };

    // * Ticket
    // * Compania a seguradora y polizas
    const policies = ref([]);
    const ticket = reactive({
      broker: {
        name: ''
      },
      employee: '',
      company: '',
      insurance: '',
      policies: '',
      endDate: '',
      messageInsurance: '',
      ticketGroupId: null
    });
    const getTicketData = async (id) => {
      loadTicket.value = true;
      try {
        // Metodo para obtener data y llenar el ticket
        const ticket_response = await store
          .dispatch(FETCH_TICKET_ID, id)
          .catch(() => router.push({ name: 'Missing' }));
        if (!ticket_response?.data) {
          loadTicket.value = false;
          return null;
        }
        const ticket_data = ticket_response.data;

        const data = ticket_data.policies;
        policies.value = [];
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          policies.value.push(element.numberPolicy);
        }
        ticket.ticketGroupId = ticket_data.ticketGroupId;
        ticket.employee = ticket_data.employee;
        ticket.company = ticket_data.company;
        ticket.messageInsurance = ticket_data.message;
        ticket.insurance = ticket_data.insuranceCompany.businessName;
        ticket.policies = policies.value

          .reduce((acc, item) => {
            return [...acc, item];
          }, '')
          .toString();
        ticket.endDate = parseDate(ticket_data.endDate).substring(0, 10);
        ticket.broker = ticket_data.broker;

        loadTicket.value = false;
        return ticket_data;

        // loadTicket.value=false;
      } catch (error) {
        loadTicket.value = false;
        console.log('error', error);
        return null;
      }
    };

    // Casos

    const cases = ref([]);

    const getAllCasesByTicketId = async (id) => {
      cases.value = [];

      const response_cases = await store
        .dispatch(FETCH_CASES, id)
        .catch((e) => e.response);

      for (let i = 0; i < response_cases.data.length; i++) {
        const obj = {
          id: '',
          tag: '',
          state: '',
          typeCaseId: 0
        };

        const caso = response_cases.data[i];

        obj.id = caso.id;
        obj.tag = caso.states
          .sort((a, b) => {
            return b.id - a.id;
          })[0]
          .state.id.toString();
        obj.state = caso.typeCase.tag;
        obj.typeCaseId = caso.typeCaseId;

        cases.value.push(obj);
      }
    };

    const redirectCase = (value) => {
      const ticketId = value.id;

      const ticketType =
        value.state === 'Out of Time'
          ? 'fuera_de_tiempo'
          : value.state.toLowerCase();

      switch (ticketType) {
        case 'fuera de tiempo: baja individual de cargas':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
      }
    };

    // * Comentarios
    const comments = ref([]);

    const normalizeComment = (raw, brokerName) => ({
      message: raw.message,
      createdAt: raw.createdAt,
      brokerName,
      author: brokerName
    });

    const getCommentsFromTicket = async (id) => {
      comments.value = [];

      const response = await store
        .dispatch(FETCH_TICKET_COMMENTS_ID, id)
        .catch((e) => e.response);

      const list = response.data ?? response;

      // Normalizamos todos los comentarios
      for (const item of list) {
        const brokerName = await getBroker(item.brokerId);
        comments.value.push(normalizeComment(item, brokerName));
      }

      fillRecordsWithComents(comments.value);
    };

    const dependents = ref([]);
    const loadingDependents = ref(false);

    const v2ExclusionColumns = [
      { title: 'Carga', dataIndex: 'dependentName', key: 'dependentName' },
      { title: 'Cobertura', dataIndex: 'coverageName', key: 'coverageName' },
      { title: 'Póliza', dataIndex: 'policyNumber', key: 'policyNumber' },
      { title: 'Grupo', dataIndex: 'groupName', key: 'groupName' }
    ];

    const v2ExclusionRows = computed(() =>
      mapV2RecordsToDisplay(dependents.value)
    );

    const availableActions = computed(() =>
      getAvailableActions(ticket_state_id.value, user_role)
    );

    const getDependents = async (id) => {
      loadingDependents.value = true;
      try {
        dependents.value = await store.dispatch(
          FETCH_V2_DEPENDENTS_EXCLUSION_OF_TICKET,
          { ticketId: id }
        );
      } catch (error) {
        // V2 endpoint may not yet be available for legacy tickets; fall
        // back to the V1 endpoint only on 404. Other errors (auth,
        // network, server) should surface to the user.
        const isNotFound =
          error.status === 404 || error?.response?.status === 404;
        if (!isNotFound) {
          dependents.value = [];
          openNotificationWithIcon(
            'error',
            'Error',
            error.message ||
              'No se pudieron cargar las coberturas a dar de baja. Por favor recargue la página.'
          );
          loadingDependents.value = false;
          return;
        }
        try {
          const v1Records = await store.dispatch(
            FETCH_DEPENDENTS_EXCLUSION_OF_TICKET,
            id
          );
          dependents.value = normalizeV1ExclusionRecords(v1Records);
        } catch (fallbackError) {
          dependents.value = [];
          openNotificationWithIcon(
            'error',
            'Error',
            'No se pudieron cargar las coberturas a dar de baja. Por favor recargue la página.'
          );
        }
      }
      loadingDependents.value = false;
    };

    const getNewCommment = async (value) => {
      const brokerName = await getBroker(value.brokerId);

      const comment = normalizeComment(
        {
          message: value.title,
          createdAt: value.description
        },
        brokerName
      );

      comments.value.push(comment);

      records_comments.push({
        title: 'Nuevo comentario',
        description: value.description
      });
    };

    const comments_ordered = computed(() => {
      return comments.value
        .map((c) => {
          const date = new Date(c.createdAt);

          return {
            title: c.message,
            description: parseDate(date),
            author: c.brokerName
          };
        })
        .sort((a, b) => new Date(a.description) - new Date(b.description));
    });

    // * Archivos
    const file_records = ref([]);
    const getFilesRecordsFromTicket = async (id) => {
      // Metodo para obtener data del registro de los archivos enviados por ticket

      file_records.value.length = 0;
      const file_records_response = await store.dispatch(
        FETCH_RECORD_FILE_TICKET,
        id
      );
      for (let i = 0; i < file_records_response.length; i++) {
        const element = file_records_response[i];
        file_records.value.push(element);
      }
    };

    // const ticketData = ref([]);
    // const crearDataToTable = async (data) =>{
    //   ticketData.value=data;
    // };

    // * Mensaje aseguradora
    const insuranceMessage = ref('');
    const getInsuranceMessage = (value) => {
      if (value.emailTicket != null) {
        insuranceMessage.value = value.emailTicket.message;
      }
    };

    // * Historial

    // Llenar el historial con Comentarios
    const fillRecordsWithComents = (data) => {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        records_comments.push({
          title: 'Nuevo comentario',
          description: element.createdAt
        });
      }
    };

    const ordered_records = computed(() => {
      loadingHistory.value = true;
      const rows = [];
      const records = [records_steps, records_comments, records_files];

      records.forEach((element) => {
        for (let i = 0; i < element.length; i++) {
          const el = element[i];
          if (el.title == 'Ejecutado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'finish'
            });
          } else if (el.title == 'Cancelado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'error'
            });
          } else {
            rows.push({
              description: new Date(el.description),
              title: el.title
            });
          }
        }
        // loadingHistory.value=false;
      });

      rows.sort(function (a, b) {
        return a.description - b.description;
      });

      for (let i = 0; i < rows.length; i++) {
        const element = rows[i];
        const fecha = parseDate(element.description); // formatDate(element.description);
        rows[i].description = fecha;
      }
      return rows;
    });

    // * Formatear fecha

    // const padTo2Digits = (num) => {
    //   return num.toString().padStart(2, '0');
    // };

    // const formatDate = (date) => {
    //   const year    = date.getFullYear();
    //   let month   = date.getMonth()+1;
    //   let day     = date.getDate();
    //   let hour    = date.getHours();
    //   let minute  = date.getMinutes();
    //   let second  = date.getSeconds();
    //   if(month.toString().length == 1) {
    //     month = `0${month}`;
    //   }
    //   if(day.toString().length == 1) {
    //     day = `0${day}`;
    //   }
    //   if(hour.toString().length == 1) {
    //     hour = `0${hour}`;
    //   }
    //   if(minute.toString().length == 1) {
    //     minute = `0${minute}`;
    //   }
    //   if(second.toString().length == 1) {
    //     second = `0${second}`;
    //   }
    //   const dateTime = `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    //   return dateTime;
    // };

    // * Cancelar ticket
    const loading = ref(false);

    // Build a refresh helper that re-pulls the stepper, ticket data
    // and V2 exclusion records. The status-actions factory calls this
    // after a successful V2 transition.
    const refreshTicketData = async () => {
      let hasError = false;
      try {
        await stepperData(id_baja);
      } catch (e) {
        console.error('stepperData failed', e);
        hasError = true;
      }
      try {
        await getTicketData(id_baja);
      } catch (e) {
        console.error('getTicketData failed', e);
        hasError = true;
      }
      try {
        await getDependents(id_baja);
      } catch (e) {
        console.error('getDependents failed', e);
        hasError = true;
      }
      if (hasError) {
        openNotificationWithIcon(
          'warning',
          'Aviso',
          'Parte de los datos no se pudo actualizar. Recargue la página para ver los cambios más recientes.'
        );
      }
    };

    // V2 status-actions factory (send-to-insurance, finish, cancel).
    // Centralises: dispatch, notification, broker email-fail check
    // and navigation back to the list.
    const statusActions = createStatusActions({
      store,
      ticketId: id_baja,
      notify: (type, title, message) =>
        openNotificationWithIcon(type, title, message),
      refresh: refreshTicketData
    });

    const openCancelModal = () => {
      Modal.confirm({
        title: () =>
          '¿Está seguro que desea cancelar el ticket de baja de cargas?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          loading.value = true;
          statusActions.cancel().finally(() => {
            loading.value = false;
          });
        },
        onCancel() {}
      });
    };

    // * Ejecutar ticket (V2)
    const ejecutar = async () => {
      loading.value = true;
      try {
        await statusActions.finish();
      } finally {
        loading.value = false;
      }
    };

    const openExecuteModal = () => {
      Modal.confirm({
        title: () =>
          '¿Está seguro que desea ejecutar el ticket de baja de cargas?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          ejecutar();
        },
        onCancel() {}
      });
    };

    // * Enviar a aseguradora (V2) — only available in state 7
    const openSendToInsuranceModal = () => {
      Modal.confirm({
        title: () =>
          '¿Está seguro que desea enviar la baja de cargas a la compañía aseguradora?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          loading.value = true;
          statusActions.sendToInsurance().finally(() => {
            loading.value = false;
          });
        },
        onCancel() {}
      });
    };

    // * Obtencion de la data principal
    const getData = async (id) => {
      try {
        // Obtengo data del ticket
        const fetchedTicketData = await getTicketData(id);

        // OBtengo mensaje de aseguradora
        getInsuranceMessage(ticket);

        // Obtengo los comentarios asociados al ticket
        await getCommentsFromTicket(id);

        // Obtengo el registro de archivos enviados por el ticket
        await getFilesRecordsFromTicket(id);

        await getAllCasesByTicketId(id);

        await getDependents(id);

        // Obtengo los grupos que pertenece el asegurado

        // Obtengo las las polizas junto con su compania aseguradora

        // // Creo la data para pasarsela a la tabla principal descriptiva
        // const data_to_table = {
        //   name:ticket.value.employee.firstName,
        //   last_name:ticket.value.employee.firstSurname,
        //   rut:ticket.value.employee.rut,
        //   company:ticket.value.company.businessName,
        //   insurance:insurance_companies.value,
        //   policies:policies.value,
        //   endDate:(parseDate(ticket.value.endDate)).substring(0,10)
        // };

        // crearDataToTable(data_to_table);

        // Actualizar data para el stepper
        await stepperData(id, fetchedTicketData);
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      getData(id_baja);
      getTicketOptionalFiles();
    });

    // * Crear data para la tabla principal
    const data_to_table = computed(() => {
      return [
        {
          key: 'Nombre',
          value:
            ticket?.employee?.fullname ||
            (ticket?.employee?.firstName && ticket?.employee?.firstSurname
              ? `${ticket.employee.firstName} ${ticket.employee.firstSurname}`
              : '')
        },
        {
          key: 'RUT titular',
          value: ticket.employee ? rutHelper.formatRut(ticket.employee.rut) : ''
        },
        {
          key: 'Empresa',
          value: ticket.company ? ticket.company.businessName : ''
        },
        {
          key: 'Aseguradora',
          value: ticket.insurance ? ticket.insurance : ''
        },
        {
          key: 'Pólizas',
          value: ticket.policies ? ticket.policies : ''
        },
        {
          key: 'Fecha de término',
          value: ticket.endDate
        },
        {
          key: 'Broker',
          value: ticket.broker.name
        }
      ];
    });

    return {
      stepper_props,
      stepper_ref,
      loadingDependents,
      loading,
      data_to_table,
      ordered_records,
      comments_ordered,
      getNewCommment,
      id_baja,
      ticket,
      routes,
      header_state_data,
      openCancelModal,
      openExecuteModal,
      openSendToInsuranceModal,
      user_role,
      showOnlyCancel,
      ticket_state_id,
      records_steps,
      records_comments,
      loadTicket,
      loadingHistory,
      v2ExclusionColumns,
      v2ExclusionRows,
      availableActions,
      cases,
      redirectCase,
      updateEndDateVisible,
      newEndDate,
      updateEndDate,
      getTicketOptionalFiles,
      ticketOptionalFiles,
      loadingOptionalFiles,
      goToTicketGroup
    };
  }
};
</script>
